var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microsoft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.783 3.783h7.826v7.826H3.783V3.783Z",
    fill: "#F35325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.391 3.783h7.826v7.826h-7.826V3.783Z",
    fill: "#81BC06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.783 12.391h7.826v7.826H3.783v-7.826Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.391 12.391h7.826v7.826h-7.826v-7.826Z",
    fill: "#FFBA08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microsoft_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 3)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgMicrosoft;